/**
 * The fixed legal-expenses-insurance destination.
 *
 * It deliberately reuses the ordinary article surface: its identity and route
 * are permanent CMS structure, while member visibility follows the article's
 * normal publication state. No historic eligibility behaviour is restored.
 */

import type { JSX } from 'react';

import { ArticleDetailPage } from './ArticleDetailPage.js';

const ARTICLE_SLUG = 'oikeusturvavakuutus';

export function OikeusturvavakuutusRoute(): JSX.Element {
  return (
    <ArticleDetailPage
      slug={ARTICLE_SLUG}
      analyticsPageKey={{ kind: 'memberRoute', route: 'legal-advice' }}
    />
  );
}
